import AbstractContext from '@/shared/models/AbstractContext';
import { present } from '@/shared/utils/typescript';
import WorkPreparationFilters from './WorkPreparationFilters';
import WorkPreparationSearchResultContainer from './WorkPreparationSearchResultContainer';

export default class WorkPreparationContext extends AbstractContext {
  constructor(
    readonly filters: WorkPreparationFilters | null = null,
    readonly container: WorkPreparationSearchResultContainer | null = null,
  ) {
    super();
  }

  getFilters(): WorkPreparationFilters {
    return present(this.filters);
  }

  getContainer(): WorkPreparationSearchResultContainer {
    return present(this.container);
  }
}